export default __webpack_public_path__ + "static/media/miguel-lopes-17.1a52b9ad.jpg";